var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { FlatList, StyleSheet, Text, View } from "react-native";
var colorAccent = "#FF5599";
var sty = StyleSheet.create({
    container: {
        width: "100%",
        flex: 1
    },
    text: {
        flex: 1,
        fontSize: 12,
        color: "#fff"
    },
    row: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderColor: "#666"
    },
    cell: {
        height: 20,
        borderColor: "#666",
        borderRightWidth: 1,
        justifyContent: "center",
        alignItems: "center"
    }
});
var PaintFormat = function (val) {
    if (typeof val == "number") {
        return val.toFixed(2);
    }
    return val;
};
var Cell = function (props) {
    var style = props.style, styleText = props.styleText, children = props.children, flex = props.flex;
    return React.createElement(View, { style: [{ flex: flex, overflow: "hidden" }, sty.cell, style] },
        React.createElement(Text, { style: [sty.text, styleText] }, props.format ? PaintFormat(children) : children));
};
var Row = function (props) {
    var _a;
    var arr = props.arr, style = props.style, styleText = props.styleText, index = props.index;
    return React.createElement(View, { style: [sty.row, style, { backgroundColor: (index % 2 != 0) ? "#00000022" : "#FFFFFF22" }] },
        React.createElement(Cell, { flex: 0.5, format: false, styleText: __assign({}, styleText) }, (_a = props.indexl) !== null && _a !== void 0 ? _a : props.index),
        React.createElement(Cell, { flex: 2, format: false, styleText: __assign(__assign({}, styleText), { color: colorAccent }) }, arr[0]),
        React.createElement(Cell, { flex: 1.5, format: true, styleText: styleText }, arr[1]),
        React.createElement(Cell, { flex: 1.5, format: true, styleText: styleText }, arr[2]),
        React.createElement(Cell, { flex: 1.5, format: true, styleText: styleText }, arr[3]),
        React.createElement(Cell, { flex: 1.5, format: true, styleText: styleText }, arr[4]),
        React.createElement(Cell, { flex: 1.5, format: true, styleText: styleText }, arr[5]));
};
export default (function (props) {
    var _a, _b;
    var data = props.data, frecuencyTable = props.frecuencyTable;
    console.log(frecuencyTable);
    return React.createElement(View, { style: [sty.container] },
        React.createElement(Row, { arr: ["", "frecuency data", "frecuency", "relative frequency", "acumulated frequency", "acumulated relative frequency"], style: { borderBottomWidth: 0 }, styleText: { color: colorAccent, fontSize: 8, textAlign: "center" }, index: 1, indexl: "" }),
        React.createElement(Row, { arr: ["key", "fd", "f", "fr", "F", "Fr"], styleText: { fontWeight: "bold", fontSize: 14, color: colorAccent }, index: 1, indexl: "#" }),
        React.createElement(View, { style: sty.container },
            React.createElement(FlatList, { data: frecuencyTable.intervals, showsVerticalScrollIndicator: false, renderItem: function (p) {
                    var _a;
                    return React.createElement(Row, { arr: [
                            frecuencyTable.intervals[p.index],
                            frecuencyTable.frequency_data[p.index],
                            frecuencyTable.frequency[p.index],
                            frecuencyTable.relative_frequency[p.index],
                            frecuencyTable.acumulated_frequency[p.index],
                            frecuencyTable.acumulated_relative_frequency[p.index],
                        ], styleText: { color: (_a = props.textColor) !== null && _a !== void 0 ? _a : "#000" }, index: p.index + 1 });
                } })),
        React.createElement(Row, { arr: ["total", frecuencyTable.sum("frequency_data"), frecuencyTable.sum("frequency"), frecuencyTable.sum("relative_frequency"), frecuencyTable.sum("acumulated_frequency"), frecuencyTable.sum("acumulated_relative_frequency")], style: { borderBottomWidth: 1 }, styleText: { color: colorAccent }, index: 1, indexl: frecuencyTable.intervals.length }),
        React.createElement(Row, { arr: ["min", frecuencyTable.min("frequency_data"), frecuencyTable.min("frequency"), frecuencyTable.min("relative_frequency"), frecuencyTable.min("acumulated_frequency"), frecuencyTable.min("acumulated_relative_frequency")], style: { borderBottomWidth: 0 }, styleText: { color: (_a = props.textColor) !== null && _a !== void 0 ? _a : "#000" }, index: 1, indexl: "" }),
        React.createElement(Row, { arr: ["max", frecuencyTable.max("frequency_data"), frecuencyTable.max("frequency"), frecuencyTable.max("relative_frequency"), frecuencyTable.max("acumulated_frequency"), frecuencyTable.max("acumulated_relative_frequency")], style: { borderBottomWidth: 0 }, styleText: { color: (_b = props.textColor) !== null && _b !== void 0 ? _b : "#000" }, index: 1, indexl: "" }));
});
